import React from 'react';
import './invoice-details-product-card.scss';
import { InvoiceLine } from '@zonofi/zono-money-store';
import { getFormattedAmount } from '@zonofi/common/functions/format-amount';
import { Divider } from '../../components';
import { ReactComponent as OfferIcon } from '@zonofi/svg-icons/offer.svg';

interface InvoiceDetailsProductCardProps {
  invoiceDetailsItem: InvoiceLine;
}

export const InvoiceDetailsProductCard: React.FC<
  InvoiceDetailsProductCardProps
> = ({ invoiceDetailsItem }) => {
  const row1_Data = [
    {
      key: 'buyingPrice',
      label: 'Buying Price',
      value: getFormattedAmount(invoiceDetailsItem?.PTR, true),
    },
    {
      key: 'orderQty',
      label: 'Order Qty',
      value: getFormattedAmount(invoiceDetailsItem?.orderedQuantity, true),
    },
    {
      key: 'gst',
      label: `GST ${invoiceDetailsItem?.GSTRate ?? 0}%`,
      value: getFormattedAmount(invoiceDetailsItem?.taxApplied, true),
    },
  ];

  const row2_Data = [
    {
      key: 'invoicedItems',
      label: 'Invoiced Items',
      value: invoiceDetailsItem?.invoicedQuantity,
    },
    {
      key: 'invoicedAmt',
      label: 'Invoiced Amt',
      value: getFormattedAmount(invoiceDetailsItem?.InvoicePTR, true),
    },
    {
      key: 'total',
      label: 'Total',
      value: invoiceDetailsItem?.lineTotalWithTax,
    },
  ];

  return (
    <div className="invoice-details-product-card">
      {/* SKU + title */}
      <div className="invoice-details-product-card-header">
        <div className="invoice-details-product-card-meta">
          <div className="invoice-details-product-card-sku font-regular">
            <span className="invoice-details-product-card-sku-text">
              SKU:{' '}
              {invoiceDetailsItem?.skuCode?.length
                ? invoiceDetailsItem?.skuCode
                : invoiceDetailsItem?.sku}
            </span>
            {invoiceDetailsItem?.lineDiscount > 0 && (
              <>
                <span className="invoice-details-product-card-sku-separator">
                  {'·'}
                </span>
                <OfferIcon width={16} height={16} />
                {/* <span className="invoice-details-product-card-offer-text font-semibold">
                  Buy 2 get {invoiceDetailsItem.lineDiscount}%
                </span> */}
              </>
            )}
          </div>

          <div className="invoice-details-product-card-title font-semibold">
            {invoiceDetailsItem?.productTitle}
          </div>
        </div>
      </div>

      <Divider className="invoice-details-divider" />

      {/* Row 1: Buying Price | Order Qty | GST */}
      <div className="invoice-details-product-card-data">
        {row1_Data.map((item) => (
          <div
            key={item?.key}
            className="invoice-details-product-card-data-cell"
          >
            <span className="invoice-details-product-card-data-label font-regular">
              {item?.label}
            </span>
            <span className="invoice-details-product-card-data-value font-semibold">
              {item?.value}
            </span>
          </div>
        ))}
      </div>

      {/* Row 2: Invoiced Items | Invoiced Amt | Total */}
      <div className="invoice-details-product-card-data column-gap">
        {row2_Data.map((item) => (
          <div
            key={item?.key}
            className="invoice-details-product-card-data-cell"
          >
            <span className="invoice-details-product-card-data-label font-regular">
              {item?.label}
            </span>
            <span className="invoice-details-product-card-data-value font-semibold">
              {item?.value}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
